<script setup lang="ts">
import { SearchMode } from '@utils/types';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { ReserveType } from '@utils/itinerary';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const layoutStore = useLayoutStore();
const { autoReserveInProcessCount } = classToRefs(layoutStore);
const gtm = useGtm();
const form = useTripSearchForm(isChangeSearch);
const flightOptions = [
    {
        label: 'داخلی',
        value: SearchMode.Domestic,
        href: '/plane-ticket',
    },
    {
        label: 'خارجی',
        value: SearchMode.Foreign,
        href: '/international-flights',
    },
];

const formAlert = computed(() =>
    autoReserveInProcessCount.value
        ? {
              title: `${autoReserveInProcessCount.value} سفر در حال رهگیری برای رزرو خودکار`,
              href: '/panel/auto-reserve',
          }
        : undefined
);
watch(form.searchMode, val => {
    if (val === SearchMode.Foreign) {
        gtm?.trackEvent({
            event: 'reserve-changed',
            reserve: 'flight-i',
        });
    }
});
onMounted(() => {
    if (!isChangeSearch) {
        layoutStore.getAutoReserveInProcessCount();
    }
});
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :loading
        :is-change-search
        :search-mode-options="flightOptions"
        :form-alert
        origin-title="فرودگاه مبدأ"
        destination-title="فرودگاه مقصد"
        :location-debounce-search="
            form.searchMode.value !== SearchMode.Domestic
        "
        :reserve-type="ReserveType.Flight"
    />
</template>
